<template>
  <div class="header">
    <div class="banner-wrap">
      <img src="@/assets/banner.jpeg" alt="" />
    </div>

    <div class="intr-wrap">
      <img src="@/assets/rule.png" alt="" />
      <img src="@/assets/rules.png" alt="" class="rules" />
    </div>

    <div class="topic">*请勾选10位奋斗者再提交点赞</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {},
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;

  .banner-wrap {
    width: 100%;
    height: 200px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .intr-wrap {
    padding: 20px;
    width: 100%;
    // height: 200px;
    img {
      width: 100%;
      height: 100%;
    }

    .rules {
      margin-top: 20px;
    }
  }

  .topic {
    color: red;
    text-align: center;
  }
}
</style>
